var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "hotspot" },
    [
      _vm.isFullScreen()
        ? _c(
            "el-tabs",
            {
              staticClass: "tabs-hotspot",
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "热点推荐", name: "first" } },
                [_c("Recommend", { ref: "recommendRef" })],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "选题生成", name: "second" } },
                [
                  _vm.list.length < 1
                    ? _c("el-empty", {
                        staticStyle: { position: "absolute", left: "42%" },
                        attrs: { "image-size": 200 },
                      })
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass: "list-selected-topic",
                      attrs: { id: "listSelectedTopic" },
                    },
                    [
                      _vm._l(_vm.list, function (item, i) {
                        return [
                          _c("div", { key: i }, [
                            _c(
                              "div",
                              {
                                staticClass: "content",
                                style:
                                  !item.isShowSelectedTopic &&
                                  !item.detailSelectedTopic.isHistory &&
                                  _vm.list.length > 1
                                    ? { marginBottom: "34rem" }
                                    : {},
                              },
                              [
                                _c("CopywritingExtract", {
                                  key: _vm.getTime,
                                  ref: item.detailExtract.id,
                                  refInFor: true,
                                  attrs: { obj: item.detailExtract },
                                  on: {
                                    copywritingExtractEmit:
                                      _vm.copywritingExtractEmit,
                                    generate: _vm.generateSelectedTopic,
                                  },
                                }),
                                item.isShowSelectedTopic
                                  ? _c("GenerateSelectedTopic", {
                                      key: item.extractTime,
                                      attrs: { obj: item.detailSelectedTopic },
                                      on: {
                                        generateSelectedTopicSend:
                                          _vm.generateSelectedTopicSend,
                                        close: function ($event) {
                                          return _vm.closeGenerateSelectedTopic(
                                            item
                                          )
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                        ]
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }